/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 批量提交账单 的 **请求配置**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/SupplySettleBill/batchCommit`
 */
const postBatchCommitRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplySettleBill/batchCommit",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchCommit",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量提交账单 的 **请求函数**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/SupplySettleBill/batchCommit`
 */
export const postBatchCommit = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postBatchCommitRequestConfig, requestData), ...args);
};
postBatchCommit.requestConfig = postBatchCommitRequestConfig;
/**
 * 接口 批量激活账单id 的 **请求配置**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/SupplySettleBill/repayByBillIds`
 */
const postRepayByBillIdsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplySettleBill/repayByBillIds",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postRepayByBillIds",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量激活账单id 的 **请求函数**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/SupplySettleBill/repayByBillIds`
 */
export const postRepayByBillIds = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postRepayByBillIdsRequestConfig, requestData),
    ...args
  );
};
postRepayByBillIds.requestConfig = postRepayByBillIdsRequestConfig;
/**
 * 接口 检查是否能重新激活 的 **请求配置**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/SupplySettleBill/checkIsCanRepay`
 */
const postCheckIsCanRepayRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplySettleBill/checkIsCanRepay",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCheckIsCanRepay",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 检查是否能重新激活 的 **请求函数**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/SupplySettleBill/checkIsCanRepay`
 */
export const postCheckIsCanRepay = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postCheckIsCanRepayRequestConfig, requestData),
    ...args
  );
};
postCheckIsCanRepay.requestConfig = postCheckIsCanRepayRequestConfig;
/**
 * 接口 账单列表 的 **请求配置**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/SupplySettleBill/getList`
 */
const postGetListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplySettleBill/getList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 账单列表 的 **请求函数**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/SupplySettleBill/getList`
 */
export const postGetList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetListRequestConfig, requestData), ...args);
};
postGetList.requestConfig = postGetListRequestConfig;
/**
 * 接口 账单详情 的 **请求配置**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/SupplySettleBill/billGoods`
 */
const postBillGoodsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplySettleBill/billGoods",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBillGoods",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 账单详情 的 **请求函数**
 *
 * @分类 旧接口文档/财务
 * @请求头 `POST /erp/SupplySettleBill/billGoods`
 */
export const postBillGoods = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postBillGoodsRequestConfig, requestData), ...args);
};
postBillGoods.requestConfig = postBillGoodsRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 账单抵扣明细 的 **请求配置**
 *
 * @分类 旧接口文档/爆版4.28(erp)
 * @请求头 `POST /erp/SupplySettleBill/listSsbReturnProfitBillDetail`
 */
const postListSsbReturnProfitBillDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/SupplySettleBill/listSsbReturnProfitBillDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postListSsbReturnProfitBillDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 账单抵扣明细 的 **请求函数**
 *
 * @分类 旧接口文档/爆版4.28(erp)
 * @请求头 `POST /erp/SupplySettleBill/listSsbReturnProfitBillDetail`
 */
export const postListSsbReturnProfitBillDetail = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postListSsbReturnProfitBillDetailRequestConfig, requestData),
    ...args
  );
};
postListSsbReturnProfitBillDetail.requestConfig =
  postListSsbReturnProfitBillDetailRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 获取银行可用余额 的 **请求配置**
 *
 * @分类 财务API/账单
 * @请求头 `POST /erp/SupplySettleBill/getBankAvabal`
 */
const postGetBankAvabalRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/SupplySettleBill/getBankAvabal",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetBankAvabal",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取银行可用余额 的 **请求函数**
 *
 * @分类 财务API/账单
 * @请求头 `POST /erp/SupplySettleBill/getBankAvabal`
 */
export const postGetBankAvabal = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetBankAvabalRequestConfig, requestData), ...args);
};
postGetBankAvabal.requestConfig = postGetBankAvabalRequestConfig;
/**
 * 接口 支付账单 的 **请求配置**
 *
 * @分类 财务API/账单
 * @请求头 `POST /erp/SupplySettleBill/payOrder`
 */
const postPayOrderRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/SupplySettleBill/payOrder",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPayOrder",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 支付账单 的 **请求函数**
 *
 * @分类 财务API/账单
 * @请求头 `POST /erp/SupplySettleBill/payOrder`
 */
export const postPayOrder = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postPayOrderRequestConfig, requestData), ...args);
};
postPayOrder.requestConfig = postPayOrderRequestConfig;
/**
 * 接口 请求余额额度 的 **请求配置**
 *
 * @分类 财务API/账单
 * @请求头 `POST /erp/SupplySettleBill/getBalance`
 */
const postGetBalanceRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/SupplySettleBill/getBalance",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetBalance",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 请求余额额度 的 **请求函数**
 *
 * @分类 财务API/账单
 * @请求头 `POST /erp/SupplySettleBill/getBalance`
 */
export const postGetBalance = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetBalanceRequestConfig, requestData), ...args);
};
postGetBalance.requestConfig = postGetBalanceRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/supplySettleBill.js